import { useDevicePanel } from '@ubnt/link-core-ui/components/BottomPanel/context/DevicePanelContext';

import { useSelector } from 'app/store';
import { devicesDeviceInstanceSelector } from 'modules/devices/slice';

import WifiStandardIcon, { WifiStandardIconProps } from 'modules/bottomPanel/components/elements/WifiStandardIcon';

const WifiStandardIconContainer = (props: Partial<WifiStandardIconProps>) => {
  const { id } = useDevicePanel();
  const wifiStandard = useSelector((state) => (id ? devicesDeviceInstanceSelector(state, id).wifiStandard : undefined));

  if (id == null || wifiStandard == null) {
    return null;
  }

  return <WifiStandardIcon wifiStandard={wifiStandard} {...props} />;
};

export default WifiStandardIconContainer;
